module.exports = __webpack_public_path__ + "static/media/mine.4973189b.jpg";